/**
 * Standardized UTM tagging for outbound share links (WhatsApp shares,
 * referrals). $referrer is weak from in-app browsers, so tagging here is
 * what makes share attribution measurable. Keep values stable — dashboards
 * filter on these exact strings.
 */

export type ShareChannel = "whatsapp" | "referral" | "copy_link";

const UTM_BY_CHANNEL: Record<ShareChannel, { source: string; medium: string }> = {
  whatsapp: { source: "whatsapp", medium: "property_share" },
  referral: { source: "realtor", medium: "referral" },
  copy_link: { source: "app", medium: "copy_link" },
};

export const withUtmParams = (
  rawUrl: string,
  channel: ShareChannel,
  campaign = "property_listing",
  content?: string,
): string => {
  try {
    const url = new URL(rawUrl);
    const { source, medium } = UTM_BY_CHANNEL[channel];
    url.searchParams.set("utm_source", source);
    url.searchParams.set("utm_medium", medium);
    url.searchParams.set("utm_campaign", campaign);
    if (content) url.searchParams.set("utm_content", content);
    return url.toString();
  } catch {
    return rawUrl;
  }
};
